import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>Will the Money Last?</h1>
        <iframe src="https://www.financialcalculators.net/librocu/money-last/" title="Will the Money Last? Calculator" scrolling="no" frameBorder="0"> </iframe>
        <IframeResize/>
    </div>
);
